<div class="overflow-scroll h-100">
    <div class="bc-mono-white">
        <ui-kit-svg (click)="back()" class="i-32 c-primary-green-800 pointer p-16" name="ic_arrow_left"></ui-kit-svg>
    </div>
    <div class="p-16" [innerHTML]="html">
    </div>
</div>
